// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.min-h-\\[36px\\] {
  min-height: 36px !important;
  height: 36px !important;
}

.invoice-select-top {
  max-height: 300px;
  overflow-y: auto;
}
.invoice-select-top *::-webkit-scrollbar {
  width: 0;
  height: 0;
  background-color: transparent;
}
.invoice-select-top *::-webkit-scrollbar-track {
  border-radius: 0;
  background-color: transparent;
}
.invoice-select-top *::-webkit-scrollbar-thumb {
  border-radius: 0;
  background-color: rgba(0, 0, 0, 0.3);
}

.invoice-select-dropdown {
  width: 100% !important;
  right: 0;
  min-width: max-content;
}
@media (max-width: 768px) {
  .invoice-select-dropdown {
    width: 100%;
  }
}

.invoice-select-body-item {
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  padding: 0.5rem;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.invoice-select-body-item:hover {
  background: var(--black1);
  color: var(--black9);
}

.dark .invoice-select-filters-item {
  background: var(--black1);
  color: var(--black5);
}
.dark .invoice-select-filters-item > span > span {
  color: var(--black9);
}

.invoice-select-filters-item {
  background: var(--black1);
  color: var(--black5);
}
.invoice-select-filters-item > span > span {
  color: var(--purple6);
}

.invoice-select-filters {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .invoice-select-filters {
    margin-bottom: 1.25rem;
  }
}
.invoice-select-filters:empty {
  display: none;
}
.invoice-select-filters-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.5rem;
  padding: 0.25rem 0.5rem;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
@media (max-width: 768px) {
  .invoice-select-filters-item {
    width: 100%;
    justify-content: space-between;
  }
}
.invoice-select-filters-item > div {
  min-width: 18px;
}

.invoice-select-checkbox {
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid rgba(0, 0, 0, 0);
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
  cursor: pointer;
  font-weight: 500;
  margin-bottom: 0;
  margin-right: 0;
}
.invoice-select-checkbox input {
  box-sizing: border-box;
  padding: 0;
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.invoice-select-checkbox input:not(:disabled):active ~ label::before {
  color: #fff;
  background-color: var(--black0);
  border-color: var(--black3);
}
.invoice-select-checkbox input:focus ~ label::before {
  border-color: var(--purple6);
  box-shadow: 0 0 0 0.2rem rgba(97, 59, 234, 0.25);
}
.invoice-select-checkbox input:checked ~ label::before {
  color: #fff;
  border-color: var(--purple6);
  background-color: var(--purple6);
}
.invoice-select-checkbox input:checked ~ label {
  color: var(--black9);
}
.invoice-select-checkbox input:checked ~ label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  border: 1px solid var(--purple6);
}
.invoice-select-checkbox label {
  position: relative;
  margin-bottom: 0;
  margin-left: 0.75rem;
  font-weight: 500;
}
.invoice-select-checkbox label:before {
  position: absolute;
  cursor: pointer;
  display: block;
  pointer-events: none;
  content: "";
  background-color: var(--white);
  top: 50%;
  transform: translateY(-51%);
  border-radius: 4px;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 19px;
  height: 19px;
  left: -1.75rem;
  border: 1px solid var(--black2) !important;
}
.invoice-select-checkbox label:after {
  top: 50%;
  cursor: pointer;
  transform: translateY(-51%);
  position: absolute;
  display: block;
  content: "";
  background: no-repeat 50%/50% 50%;
  width: 19px;
  height: 19px;
  left: -1.75rem;
  border-radius: 4px;
}

.invoice-select-custom {
  display: flex;
  flex-direction: column;
}
.invoice-select-custom-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  padding: 0 0.5rem 0.5rem 0.5rem;
}
.invoice-select-custom-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0.5rem 1rem 0.5rem;
  color: var(--black9);
  border-bottom: 1px solid var(--black2);
  margin-bottom: 1rem;
}

.invoices-select-backdrop {
  position: fixed;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(1px);
  left: 0;
  z-index: 0;
  background: rgba(18, 20, 23, 0.3215686275);
  top: 3.5rem;
  display: none;
}

.dropdown-menu-open .invoices-select-trigger .invoices-select-trigger-arrow {
  transition: transform 0.3s ease;
  transform: rotate(-180deg) !important;
}

.dropdown-menu-open .invoices-select-trigger {
  border-color: var(--purple6);
  color: var(--black9);
}

.invoices-select-trigger {
  border-radius: 0.5rem;
  color: var(--black5);
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-drag: none;
  user-select: none;
  height: 36px;
  justify-content: space-between;
  gap: 1rem;
  transition: transform 0.3s ease;
  background-color: var(--white);
  border: 1px solid var(--black2);
  box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);
}
.invoices-select-trigger:hover {
  color: var(--black9);
  transition: transform 0.3s ease;
}
.invoices-select-trigger:hover .invoices-select-trigger-arrow {
  transition: transform 0.3s ease;
  transform: rotate(-90deg);
}
.invoices-select-trigger-info {
  display: flex;
  font-weight: 500;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}
.invoices-select-trigger-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 0.75rem !important;
  height: 0.75rem !important;
  transition: transform 0.3s ease;
}

div.invoice-select-value-search {
  flex-wrap: nowrap;
  flex-direction: row-reverse;
  padding-left: 1rem;
  gap: 0;
}
div.invoice-select-value-search .dropdown-custom-item-value {
  padding-left: 0 !important;
}
div.invoice-select-value-search .react-select__input-container {
  padding-left: 1rem !important;
}
div.invoice-select-value-search > .dropdown-custom-item-value + div {
  padding-left: calc(1rem - 4px) !important;
  position: relative;
  height: 36px;
  left: -3px;
}
div.invoice-select-value-search > .dropdown-custom-item-value + div input {
  padding-left: 1rem;
}

div.invoice-select-value {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  height: 35px;
  min-width: 100px;
  width: max-content;
  justify-content: flex-start;
  top: -1px;
  position: relative;
  padding: 0.25rem 0;
  line-height: 1rem;
}
div.invoice-select-value > .dropdown-custom-item-value {
  height: 100%;
  position: relative;
}

.switch-button {
  width: auto;
  height: 2.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--white);
  border: 1px solid var(--black2);
  box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);
  border-radius: 0.5rem;
}
.switch-button button {
  height: 100%;
  background-color: transparent;
  font-weight: 500;
  color: var(--black5);
}
.switch-button button.active {
  color: var(--purple6);
}
.switch-button button:first-child {
  padding-left: 1rem;
  padding-right: 0.5rem;
}
.switch-button button:last-child {
  padding-left: 0.5rem;
  padding-right: 1rem;
}
@media (max-width: 768px) {
  .switch-button button {
    width: 50%;
  }
}
.switch-button .vertical-line {
  width: 1px;
  height: 0.75rem;
  background-color: var(--black2);
}

.export-csv-button {
  display: flex;
  margin: 0 auto;
  margin-right: 0;
}

.export-csv-tooltip {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  text-align: right;
}

.invoice-list-screen {
  width: 100%;
  padding-bottom: 1rem;
}
.invoice-list-screen .screen-filters {
  width: 100%;
}
.invoice-list-screen .screen-filters > div {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.75rem;
}
@media (max-width: 768px) {
  .invoice-list-screen .screen-filters > div {
    width: 100%;
    flex-wrap: nowrap;
  }
  .invoice-list-screen .screen-filters > div > div {
    width: 100%;
  }
}

.invoice-list-icon {
  border: 1px solid var(--black1);
  border-radius: 0.5rem;
  width: 2.25rem;
  min-width: 2.25rem;
  height: 2.25rem;
  margin-right: 0.75rem;
  background: var(--white);
  box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
}

.invoice-list-id {
  display: flex;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--black4);
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/invoices/invoices/style.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,uBAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;AACF;AAEE;EACE,QAAA;EACA,SAAA;EACA,6BAAA;AAAJ;AAEI;EACE,gBAAA;EACA,6BAAA;AAAN;AAGI;EACE,gBAAA;EACA,oCAAA;AADN;;AAOA;EACE,sBAAA;EACA,QAAA;EACA,sBAAA;AAJF;AAME;EALF;IAMI,WAAA;EAHF;AACF;;AAOE;EACE,qBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAJJ;AAMI;EACE,yBAAA;EACA,oBAAA;AAJN;;AASA;EACE,yBAAA;EACA,oBAAA;AANF;AASI;EACE,oBAAA;AAPN;;AAYA;EACE,yBAAA;EACA,oBAAA;AATF;AAYI;EACE,qBAAA;AAVN;;AAeA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAZF;AAcE;EANF;IAOI,sBAAA;EAXF;AACF;AAaE;EACE,aAAA;AAXJ;AAcE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAZJ;AAcI;EAVF;IAWI,WAAA;IACA,8BAAA;EAXJ;AACF;AAaI;EACE,eAAA;AAXN;;AAgBA;EACE,kCAAA;EACA,kCAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAbF;AAmBE;EACE,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAjBJ;AAmBI;EACE,WAAA;EACA,+BAAA;EACA,2BAAA;AAjBN;AAoBI;EACE,4BAAA;EACA,gDAAA;AAlBN;AAqBI;EACE,WAAA;EACA,4BAAA;EACA,gCAAA;AAnBN;AAsBI;EACE,oBAAA;AApBN;AAuBI;EACE,oEAAA;EACA,gCAAA;AArBN;AAyBE;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AAvBJ;AAyBI;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,WAAA;EACA,8BAAA;EACA,QAAA;EACA,2BAAA;EACA,kBAAA;EACA,4GAAA;EAEA,WAAA;EACA,YAAA;EACA,cAAA;EACA,0CAAA;AAxBN;AA2BI;EACE,QAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,iCAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AAzBN;;AA8BA;EACE,aAAA;EACA,sBAAA;AA3BF;AA6BE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,+BAAA;AA3BJ;AA8BE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,kCAAA;EACA,oBAAA;EACA,sCAAA;EACA,mBAAA;AA5BJ;;AAgCA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,OAAA;EACA,UAAA;EACA,0CAAA;EACA,WAAA;EACA,aAAA;AA7BF;;AAgCA;EACE,+BAAA;EACA,qCAAA;AA7BF;;AAgCA;EACE,4BAAA;EACA,oBAAA;AA7BF;;AAgCA;EACE,qBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,8BAAA;EACA,SAAA;EACA,+BAAA;EACA,8BAAA;EACA,+BAAA;EACA,4CAAA;AA7BF;AA+BE;EACE,oBAAA;EACA,+BAAA;AA7BJ;AA8BI;EACE,+BAAA;EACA,yBAAA;AA5BN;AAgCE;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AA9BJ;AAiCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,0BAAA;EACA,+BAAA;AA/BJ;;AAmCA;EACE,iBAAA;EACA,2BAAA;EACA,kBAAA;EACA,MAAA;AAhCF;AAkCE;EACE,0BAAA;AAhCJ;AAmCE;EACE,6BAAA;AAjCJ;AAoCE;EACE,yCAAA;EACA,kBAAA;EAEA,YAAA;EACA,UAAA;AAnCJ;AAqCI;EACE,kBAAA;AAnCN;;AAwCA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AArCF;AAuCE;EACE,YAAA;EACA,kBAAA;AArCJ;;AA4CA;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;EACA,4CAAA;EACA,qBAAA;AAzCF;AA2CE;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,oBAAA;AAzCJ;AA2CI;EACE,qBAAA;AAzCN;AA4CI;EACE,kBAAA;EACA,qBAAA;AA1CN;AA4CI;EACE,oBAAA;EACA,mBAAA;AA1CN;AA6CI;EAnBF;IAoBI,UAAA;EA1CJ;AACF;AA6CE;EACE,UAAA;EACA,eAAA;EACA,+BAAA;AA3CJ;;AA+CA;EACE,aAAA;EACA,cAAA;EACA,eAAA;AA5CF;;AA+CA;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,iBAAA;AA5CF;;AA+CA;EACE,WAAA;EACA,oBAAA;AA5CF;AA8CE;EACE,WAAA;AA5CJ;AA8CI;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AA5CN;AA+CI;EACE;IACE,WAAA;IACA,iBAAA;EA7CN;EA+CM;IACE,WAAA;EA7CR;AACF;;AAmDA;EACE,+BAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,wBAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhDF;;AAmDA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAhDF","sourcesContent":["div.min-h-\\[36px\\] {\n  min-height: 36px !important;\n  height: 36px !important;\n}\n\n.invoice-select-top {\n  max-height: 300px;\n  overflow-y: auto;\n\n\n  *::-webkit-scrollbar {\n    width: 0;\n    height: 0;\n    background-color: transparent;\n\n    &-track {\n      border-radius: 0;\n      background-color: transparent;\n    }\n\n    &-thumb {\n      border-radius: 0;\n      background-color: rgba(0, 0, 0, 0.3);\n    }\n  }\n\n}\n\n.invoice-select-dropdown {\n  width: 100% !important;\n  right: 0;\n  min-width: max-content;\n\n  @media (max-width: 768px) {\n    width: 100%;\n  }\n}\n\n.invoice-select-body {\n  &-item {\n    border-radius: 0.5rem;\n    transition: all .3s ease;\n    padding: 0.5rem;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n\n    &:hover {\n      background: var(--black1);\n      color: var(--black9);\n    }\n  }\n}\n\n.dark .invoice-select-filters-item {\n  background: var(--black1);\n  color: var(--black5);\n\n  & > span {\n    & > span {\n      color: var(--black9);\n    }\n  }\n}\n\n.invoice-select-filters-item {\n  background: var(--black1);\n  color: var(--black5);\n\n  & > span {\n    & > span {\n      color: var(--purple6);\n    }\n  }\n}\n\n.invoice-select-filters {\n  display: flex;\n  gap: .75rem;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n\n  @media (max-width: 768px) {\n    margin-bottom: 1.25rem;\n  }\n\n  &:empty {\n    display: none;\n  }\n\n  &-item {\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n    border-radius: .5rem;\n    padding: .25rem .5rem;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n\n    @media (max-width: 768px) {\n      width: 100%;\n      justify-content: space-between;\n    }\n\n    & > div {\n      min-width: 18px;\n    }\n  }\n}\n\n.invoice-select-checkbox {\n  background-color: #0000;\n  border: 1px solid #0000;\n  position: relative;\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5rem;\n  cursor: pointer;\n  font-weight: 500;\n  margin-bottom: 0;\n  margin-right: 0;\n\n  &:hover {\n\n  }\n\n  input {\n    box-sizing: border-box;\n    padding: 0;\n    position: absolute;\n    z-index: -1;\n    opacity: 0;\n\n    &:not(:disabled):active ~ label::before {\n      color: #fff;\n      background-color: var(--black0);\n      border-color: var(--black3);\n    }\n\n    &:focus ~ label::before {\n      border-color: var(--purple6);\n      box-shadow: 0 0 0 0.2rem rgb(97 59 234 / 25%);\n    }\n\n    &:checked ~ label::before {\n      color: #fff;\n      border-color: var(--purple6);\n      background-color: var(--purple6);\n    }\n\n    &:checked ~ label {\n      color: var(--black9);\n    }\n\n    &:checked ~ label::after {\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e\") !important;\n      border: 1px solid var(--purple6);\n    }\n  }\n\n  label {\n    position: relative;\n    margin-bottom: 0;\n    margin-left: .75rem;\n    font-weight: 500;\n\n    &:before {\n      position: absolute;\n      cursor: pointer;\n      display: block;\n      pointer-events: none;\n      content: \"\";\n      background-color: var(--white);\n      top: 50%;\n      transform: translateY(-51%);\n      border-radius: 4px;\n      transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n      width: 19px;\n      height: 19px;\n      left: -1.75rem;\n      border: 1px solid var(--black2) !important;\n    }\n\n    &:after {\n      top: 50%;\n      cursor: pointer;\n      transform: translateY(-51%);\n      position: absolute;\n      display: block;\n      content: \"\";\n      background: no-repeat 50%/50% 50%;\n      width: 19px;\n      height: 19px;\n      left: -1.75rem;\n      border-radius: 4px;\n    }\n  }\n}\n\n.invoice-select-custom {\n  display: flex;\n  flex-direction: column;\n\n  &-body {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    width: 100%;\n    padding: 0 0.5rem 0.5rem 0.5rem;\n  }\n\n  &-header {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 1rem;\n    padding: 0.5rem .5rem 1rem .5rem;\n    color: var(--black9);\n    border-bottom: 1px solid var(--black2);\n    margin-bottom: 1rem;\n  }\n}\n\n.invoices-select-backdrop {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  backdrop-filter: blur(1px);\n  left: 0;\n  z-index: 0;\n  background: rgba(18, 20, 23, 0.3215686275);\n  top: 3.5rem;\n  display: none;\n}\n\n.dropdown-menu-open .invoices-select-trigger .invoices-select-trigger-arrow {\n  transition: transform 0.3s ease;\n  transform: rotate(-180deg) !important;\n}\n\n.dropdown-menu-open .invoices-select-trigger {\n  border-color: var(--purple6);\n  color: var(--black9);\n}\n\n.invoices-select-trigger {\n  border-radius: 0.5rem;\n  color: var(--black5);\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 0.75rem;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -webkit-user-drag: none;\n  user-select: none;\n  height: 36px;\n  justify-content: space-between;\n  gap: 1rem;\n  transition: transform 0.3s ease;\n  background-color: var(--white);\n  border: 1px solid var(--black2);\n  box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);\n\n  &:hover {\n    color: var(--black9);\n    transition: transform 0.3s ease;\n    .invoices-select-trigger-arrow {\n      transition: transform 0.3s ease;\n      transform: rotate(-90deg);\n    }\n  }\n\n  &-info {\n    display: flex;;\n    font-weight: 500;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.5rem;\n  }\n\n  &-arrow {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 0.75rem !important;\n    height: 0.75rem !important;\n    transition: transform 0.3s ease;\n  }\n}\n\ndiv.invoice-select-value-search {\n  flex-wrap: nowrap;\n  flex-direction: row-reverse;\n  padding-left: 1rem;\n  gap: 0;\n\n  .dropdown-custom-item-value {\n    padding-left: 0 !important;\n  }\n\n  .react-select__input-container {\n    padding-left: 1rem !important;\n  }\n\n  & > .dropdown-custom-item-value + div {\n    padding-left: calc(1rem - 4px) !important;\n    position: relative;\n    //top: -1px;\n    height: 36px;\n    left: -3px;\n\n    input {\n      padding-left: 1rem;\n    }\n  }\n}\n\ndiv.invoice-select-value {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  height: 35px;\n  min-width: 100px;\n  width: max-content;\n  justify-content: flex-start;\n  top: -1px;\n  position: relative;\n  padding: 0.25rem 0;\n  line-height: 1rem;\n\n  & > .dropdown-custom-item-value {\n    height: 100%;\n    position: relative;\n  }\n}\n\n\n\n\n.switch-button {\n  width: auto;\n  height: 2.25rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--white);\n  border: 1px solid var(--black2);\n  box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);\n  border-radius: 0.5rem;\n\n  button {\n    height: 100%;\n    background-color: transparent;\n    font-weight: 500;\n    color: var(--black5);\n\n    &.active {\n      color: var(--purple6);\n    }\n\n    &:first-child {\n      padding-left: 1rem;\n      padding-right: 0.5rem;\n    }\n    &:last-child {\n      padding-left: 0.5rem;\n      padding-right: 1rem;\n    }\n\n    @media (max-width: 768px) {\n      width: 50%;\n    }\n  }\n\n  .vertical-line {\n    width: 1px;\n    height: 0.75rem;\n    background-color: var(--black2);\n  }\n}\n\n.export-csv-button {\n  display: flex;\n  margin: 0 auto;\n  margin-right: 0;\n}\n\n.export-csv-tooltip {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  text-align: right;\n}\n\n.invoice-list-screen {\n  width: 100%;\n  padding-bottom: 1rem;\n\n  .screen-filters {\n    width: 100%;\n\n    & > div {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-end;\n      gap: .75rem;\n    }\n\n    @media (max-width: 768px) {\n      & > div {\n        width: 100%;\n        flex-wrap: nowrap;\n\n        & > div {\n          width: 100%;\n        }\n      }\n    }\n  }\n}\n\n.invoice-list-icon {\n  border: 1px solid var(--black1);\n  border-radius: .5rem;\n  width: 2.25rem;\n  min-width: 2.25rem;\n  height: 2.25rem;\n  margin-right: .75rem;\n  background: var(--white);\n  box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.invoice-list-id {\n  display: flex;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 15px;\n  color: var(--black4);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
